<template>
  <div class="row">
    <div class="col-lg-4" v-if="checkForPermission(add_user_role_permission)">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title mb-4">Add User Role</h4>
          <new-user-role-form button_text="Add User Role" @roleAction="addNewRole"/>
        </div>
      </div>
    </div>
    <div class="col-lg-8">
      <div class="card min-height">
        <div class="card-body">
          <h4 class="card-title mb-4">All User Roles</h4>
          <TableLoading v-if="roles.page === 0"/>
          <user-roles-table v-else :rows="roles.objects" @refetch="refetchRole"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserRolesTable from "@/components/roles/user-roles-table"
import NewUserRoleForm from "@/components/roles/new-user-role-form";
import {ALL_ROLES} from "@/gql";
import {mapActions} from "vuex";
import TableLoading from "@/components/TableLoading";
import {successToast} from "@/components/successToast";
import {permissions} from "@/router/permissions";

export default {
components: {TableLoading, NewUserRoleForm, UserRolesTable},
name: "user-roles-component",
  data() {
    return {
      roles: {
        page: 0,
        objects: []
      },
      add_user_role_permission: permissions.add_user_role_permission,
    }
  },
  apollo: {
    roles: {
      query: ALL_ROLES,
      variables (){
        return {
          page: 0,
          perPage: 30
        }
      }
    },
  },
  methods: {
    ... mapActions({
      addRole: 'user/addNewUserRole'
    }),
    async addNewRole(data){
      await this.addRole(data).then(() => {
        this.refetchRole()
        successToast(`New role added successfully`)
      })
    },
    refetchRole(){
      this.$apollo.queries.roles.refetch()
    }
  }
}
</script>

<style scoped>

</style>
